<style lang="scss" scoped>

</style>

<template>
    <Modal ref="modal">
        
        <template v-slot:title>
            <span v-if="isMode('new')">Ruhewasserstand dokumentieren</span>
            <span v-if="isMode('new_completely')">Ruhewasserstand dokumentieren</span>
            <span v-if="isMode('complete')">Ruhewasserstand abschließen</span>     
            <span v-if="isMode('view')">Ruhewasserstand</span>    
            <span v-if="isMode('alter')">Ruhewasserstand ändern</span>
        </template>
        
        <!-- Select WaterPoint -->
        
        <div class="row mt-1 mb-3">
            <div class="col-12">
                <label class="form-label">
                    Entnahmestelle
                </label>
                <WaterPointSelect v-model:waterPointId="waterPointId" :disabled="isProfileWaterPoint" referrer="/level?action=newlevel"></WaterPointSelect>
            </div>
        </div>    
       
        <Alert type="danger" :show="alert.waterPointMissing" :timeout="6000">
                <template v-slot:title>Entnahmestelle fehlt</template>
                Bitte wählen Sie eine Entnahmestelle
        </Alert>
       
        <Alert type="danger" :show="alert.waterPoint">
            <template v-slot:title>Bitte bachten Sie</template>
                Die jetzt dem Schlag zugeordnete Entnahmestelle kann später nicht
                mehr verändert werden. Wenn Sie sicher sind, dass Sie die korrekte
                Entnahmestelle ausgewählt haben, klicken Sie bitte erneut auf „Speichern“.
        </Alert>
       
        <!-- Start Date --> 
                 
        <div class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Start der Dokumentation</label>
            </div>
            <div class="col">
                <div class="input-icon">
                  <DatePickerInput ref="startDate" v-model:date="startDate" :minDate="getMinDateTime().format('YYYY-MM-DD')" :maxDate="getMaxDateTime().format('YYYY-MM-DD')" :disabled="isMode(['view','complete','alter'])"></DatePickerInput>
                  <span class="input-icon-addon">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <rect x="4" y="5" width="16" height="16" rx="2"></rect>
                        <line x1="16" y1="3" x2="16" y2="7"></line>
                        <line x1="8" y1="3" x2="8" y2="7"></line>
                        <line x1="4" y1="11" x2="20" y2="11"></line>
                        <line x1="11" y1="15" x2="12" y2="15"></line>
                        <line x1="12" y1="15" x2="12" y2="18"></line>
                     </svg>
                  </span>
                </div>
            </div>
            <div class="col">
                <TimeInput v-model:value="startTime" mask="0[0]:0[0]" placeholder="Uhrzeit (HH:MM)" :disabled="isMode(['view','complete','alter'])"></TimeInput>     
            </div>
        </div>
        
        <!-- Well Level --> 

        <div class="row mt-3 mb-2">
            <div class="col-12 mb-0">
                <label v-if="isMode(['view','new_completely','complete','alter']) || true" class="form-label">
                    Abstand zur Messmarke in m
                </label>
            </div>
            <div class="col">
                <FloatInput v-model:value="stillWaterLevel" :imaskOptions="{mask:'0[000]{,}00 m',overwrite: true, lazy:false}"
                :digits="2" placeholder="Abstand in m" v-on:focusOut="countStartChanged" :disabled="isMode(['view','complete'])" :focus="!countStart && isMode('new_completely')">
                </FloatInput>
            </div>
        </div>
        
        <Alert type="danger" :show="alert.stillWaterLevel" :timeout="6000">
            <template v-slot:title>Abstand zur Messmarke fehlt</template>
            Bitte tragen Sie den Ruhewasserstand als Abstand zur Messmarke ein
        </Alert>
        
        <!-- Comment --> 
        
        <div v-if="(comment && isMode('view')) || isMode('alter')" class="row mt-3 mb-2">
            <div class="col-12 mb-0">
                <label class="form-label">Begründung für die Änderung<span class="form-label-description">{{ comment ? comment.length: 0 }}/150</span></label>
                <textarea v-model="comment" :disabled="['view'].includes(mode)" class="form-control" maxlength="150" name="example-textarea-input" rows="4" placeholder="Begründung für die Änderung"></textarea>
            </div>
        </div>
       
        <Alert type="danger" :show="alert.comment" :timeout="6000">
            <template v-slot:title>Begründung erforderlich</template>
            Eine nachträgliche Änderungen der Eingaben ist nur mit Begründung von mindestens {{ minCommentLength }} Zeichen möglich
        </Alert>
        
        
        <!-- Modal Footer --> 
       
        <template v-slot:footer>
            <template v-if="isMode(['new','new_completely','complete'])">
                <button type="button" class="btn me-auto" @click="closeModal">
                    Abbrechen
                </button>
                
                <a href="#" class="btn btn-info ms-auto" @click="submit">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
                      <polyline points="7 11 12 16 17 11" />
                      <line x1="12" y1="4" x2="12" y2="16" /> 
                  </svg>
                    Speichern
                </a>
            </template>
            <template v-if="isMode(['view'])">
                <button type="button" class="btn me-auto" @click="closeModal">
                    Ok
                </button>
                
                <a href="#" class="btn btn-info ms-auto" @click="changeMode('alter')">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M9 7h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3" />
                      <path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3" />
                      <line x1="16" y1="5" x2="19" y2="8" />
                  </svg>
                   Dokumentation ändern
                </a>
            </template>
            <template v-if="isMode(['alter'])">
                <button type="button" class="btn me-auto" @click="closeModal">
                    Abbrechen
                </button>
                
                <a href="#" class="btn btn-info ms-auto" @click="submit">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
                      <polyline points="7 11 12 16 17 11" />
                      <line x1="12" y1="4" x2="12" y2="16" />   
                  </svg>
                    Änderungen speichern
                </a>
            </template>            
        </template>
    </Modal>
</template>


<script>
import * as dayjs from 'dayjs';
import MinMax from 'dayjs/plugin/minMax';
dayjs.extend(MinMax)

import Modal from '@/components/Modal.vue';
import Alert from '@/components/Alert.vue';
import DatePickerInput from '@/components/input/DatePickerInput.vue';
import TimeInput from '@/components/input/TimeInput.vue';
import FloatInput from '@/components/input/FloatInput.vue';
import WaterPointSelect from '@/components/waterpoint/WaterPointSelect.vue';

export default {
    name: 'Precipitation Alter Modal',
    components: {
        Modal,
        Alert,
        DatePickerInput,
        WaterPointSelect,
        FloatInput,
        TimeInput
    },
    inject: [
        'state'
    ],
    props: {
        mode: {
            type: String,
            default: 'new'
        },
        profile: {
            type: Object,
            default: undefined
        },
        irrigation: {
            type: Object,
            default: null
        },
        irrigationList: {
            type: Array,
            default: null
        }
    },
    data: function () {
        return {
            waterPointId: null,
            startDate: null,
            startTime: null,
            stillWaterLevel: null,    
            comment: '',
            alert: {
                waterPoint: false,
                waterPointMissing: false,
                stillWaterLevel: false,
                comment: false
            },
            minCommentLength: 5,
            createComplete: false
        }
    },
    computed: {
        isWaterPointSelected: function () {
            return !(this.waterPointId == null);          
        },
        isProfileWaterPoint: function () {
            return !(this.profile.waterPointId == null);          
        }
    },
    methods: {
        openModal: function () {
            this.set(this.irrigation);
            this.$nextTick(function() { 
                this.$refs.modal.openModal();        
            });
        },
        closeModal: function () {
            this.$refs.modal.closeModal();                   
        },
        changeMode: function (mode) {
            this.$emit('update:mode', mode);        
        },
        submit: function () {
            if (!this.validateForm()) {
                return
            }
            
            let id = null;
            if (this.isMode('complete') && this.irrigation) {
                id = parseInt(this.irrigation.id);
            }
            
            let refId = null;
            if (this.isMode('alter') && this.irrigation) {
                if (this.irrigation.refId === null) {
                    refId = parseInt(this.irrigation.id);
                } else {
                    refId = parseInt(this.irrigation.refId);
                }
            }
            
            let irrigation = {
                profileId: this.state.profile.id,
                waterpointId: parseInt(this.waterPointId),
                id: id,
                refId: refId,
                datetime: '{}T{}:{}'.format(this.startDate, this.startTime, dayjs().format('ss')),
                stillWaterLevel: this.stillWaterLevel,
                normalWaterLevel: null,
                comment: this.isMode('new') ? null : this.comment,
            }
            
            this.$emit('submit', irrigation);
            this.closeModal();            
        },
        validateForm: function () {
            
            this.alert.waterPointMissing = false;
            if ( !this.waterPointId ) {
                this.$nextTick(function() { 
                    this.alert.waterPointMissing = true;
                });
                return false;
            }
            
            this.alert.stillWaterLevel = false;
            if ( !this.stillWaterLevel ) {
                this.$nextTick(function() { 
                    this.alert.stillWaterLevel = true;
                });
                return false;
            }
            
            this.alert.comment = false;
            if ( this.isMode('alter') && (this.comment? this.comment.length < this.minCommentLength: true)) {
                this.$nextTick(function() { 
                    this.alert.comment = true;
                });
                return false;
            }
            
            if (!this.isProfileWaterPoint && this.isWaterPointSelected && this.alert.waterPoint == false) {
                this.$nextTick(function() { 
                    this.alert.waterPoint = true;
                });
                return false;
            }
            

            return true;
        },
        isMode: function (modes) {
            if ( !Array.isArray(modes) ) {
                modes = [modes];    
            }
            return modes.includes(this.mode);
        },
        getDefaultDateTime: function () {
            return dayjs.max(
                this.makeDate(dayjs().format('DD.MM')),
                this.getMinDateTime()
            )
        },
        getMinDateTime: function () {
            let listMaxDateItem = this.getListMaxDateItem();
            
            if (listMaxDateItem) {
                return dayjs(listMaxDateItem.datetime);
            }
            return this.makeDate('01.01');
        },
        getMaxDateTime: function () {
            return dayjs.min(
                dayjs(),
                this.makeDate('31.12')
            )
        },
        getMinCountStart: function () {
            let listMaxDateItem = this.getListMaxDateItem();
            
            if (listMaxDateItem) {
                return listMaxDateItem.countStart;
            }
            return null;
        },
        dateToISOString: function (date) {
            return date.toISOString().substring(0, 10);
        },
        makeDate: function (ds) {
            return dayjs('{}-{}-{}'.format(
                this.state.profile.year,
                parseInt(ds.split('.')[1]),
                parseInt(ds.split('.')[0])
            ));
        },
        getListMaxDateItem: function () {
            if (this.irrigationList.length == 0 ) {
                return null;
            }
                        
            return this.irrigationList.reduce( function (a, b) {
                return dayjs(a.datetime) > dayjs(b.datetime)  ? a : b;
            })
            
        },
        set: function (irrigation) {
            
            if ( !(irrigation.waterpointId === undefined)) {
                this.waterPointId = parseInt(irrigation.waterpointId);
            } else {                
                this.waterPointId = this.profile.waterPointId;
            }
            
            if (irrigation.datetime) {
                this.startDate = dayjs(irrigation.datetime).format('YYYY-MM-DD');
                this.startTime = dayjs(irrigation.datetime).format('HH:mm'); 
            } else {
                this.startDate = this.getDefaultDateTime().format('YYYY-MM-DD');
                this.startTime = dayjs().format('HH:mm');             
            }
           
            if ( !(irrigation.stillWaterLevel === undefined)) {
                this.stillWaterLevel = irrigation.stillWaterLevel;
            } else {
                this.stillWaterLevel = null;
            }
            
            if ( !(irrigation.comment === undefined)) {
                this.comment = irrigation.comment;
            } else {
                this.comment = null;
            }
            
        }
    },
    watch: {
        mode: function (new_value, old_value) {
            if ( old_value == 'view' &&  new_value == 'alter') {
                this.images = [];
            }
        }, 
        createComplete: function (new_value, old_value) {
            if ( old_value === false && new_value === true) {
                this.changeMode('new_completely');
            } else if ( old_value === true && new_value === false) {
                this.changeMode('new');
            }
        }
    },
    created: function () {
        
    },
    mounted: function () {
        
    }
}

</script>